import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type AlertFormSchema, alertFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { AlertForm } from "@/forms/alert-form";
import { client } from "@/hono";

/** Props Interface */
interface AddAlertModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
}

export function AddAlertModal({ isOpen, onClose, onComplete }: AddAlertModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(alertFormSchema),
		defaultValues: {
			levelType: "info",
		},
	});

	/** Fucntions */
	async function handleOnSubmit(json: AlertFormSchema) {
		const response = await client.organizations.alerts.$post({ json });
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("dashboard.alerts.add_alert")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit, console.error)}
			>
				<Modal.Body>
					<AlertForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
